import type { ReactNode } from 'react';
import { cn } from '../../../../../../lib/utils';
import { secondaryText } from '../../../../../../styling/stylingHelper';

/** One aggregate-totals chip on the revenue-check summary line — tinted amber when non-zero. */
export function TrivecSummaryChip({ label, value }: { label: string; value: number }) {
  return (
    <div className={cn('inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg border border-gray-200 dark:border-gray-700', value > 0 ? 'bg-amber-50 dark:bg-amber-900/10' : 'bg-gray-50 dark:bg-gray-800')}>
      <span className={cn('tabular-nums font-semibold text-xs', value > 0 ? 'text-amber-700 dark:text-amber-300' : secondaryText)}>{value}</span>
      <span className={cn(secondaryText, 'text-xs')}>{label}</span>
    </div>
  );
}

/** A single titled finding block (rendered only when it has entries). */
export function TrivecFindingBlock({ title, tone, children }: { title: string; tone: 'warn' | 'info' | 'error'; children: ReactNode }) {
  const toneCls = tone === 'error'
    ? 'text-red-700 dark:text-red-300'
    : tone === 'warn'
    ? 'text-amber-700 dark:text-amber-300'
    : 'text-blue-700 dark:text-blue-300';
  return (
    <div className="space-y-1">
      <div className={cn('text-xs font-semibold', toneCls)}>{title}</div>
      <ul className="space-y-0.5 pl-3">{children}</ul>
    </div>
  );
}
